/* __next_internal_client_entry_do_not_use__ SaveToBoard auto */ import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import * as React from "react";
import styled from "styled-components";
import { FavoriteButton } from "@faire/retailer-visitor-shared/components/Favorite/FavoriteButton";
import { closeSaveToBoardToastIfActive } from "@faire/retailer-visitor-shared/features/RetailerBoards/Components/SaveToBoardToast";
import { SaveToBoardContext } from "@faire/retailer-visitor-shared/features/RetailerBoards/Context";
import { useSaveToBoard, useRemoveFromBoard, useMoveToBoard } from "@faire/retailer-visitor-shared/features/RetailerBoards/hooks/boardItemsHooks";
import { LazySelectBoardModal } from "@faire/retailer-visitor-shared/features/RetailerBoards/modals/LazySelectBoardModal";
import { trackBoardsEvent } from "@faire/retailer-visitor-shared/features/RetailerBoards/utils";
export var SaveToBoard = function(props) {
    var _props_boardTokens;
    // checking length first instead of accessing the first element directly due to a mobx warning
    // https://github.com/mobxjs/mobx/issues/2913
    var strictLocalize = useStrictLocalization().strictLocalize;
    var initialBoardToken = ((_props_boardTokens = props.boardTokens) === null || _props_boardTokens === void 0 ? void 0 : _props_boardTokens.length) ? props.boardTokens[0] : undefined;
    // currently we support a single board per product
    var savedToBoardTokenRef = React.useRef(initialBoardToken);
    var _React_useState = _sliced_to_array(React.useState(isNotUndefined(initialBoardToken)), 2), favorited = _React_useState[0], setFavorited = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), selectBoardModalOpen = _React_useState1[0], setSelectBoardModalOpen = _React_useState1[1];
    var saveToBoardContext = React.useContext(SaveToBoardContext);
    var saveToBoard = useSaveToBoard(function() {
        return setSelectBoardModalOpen(true);
    }).saveToBoard;
    var removeFromBoard = useRemoveFromBoard().removeFromBoard;
    var moveToBoard = useMoveToBoard().moveToBoard;
    var _props_productToken = props.productToken, productToken = _props_productToken === void 0 ? "" : _props_productToken;
    React.useEffect(function() {
        return function() {
            return closeSaveToBoardToastIfActive();
        };
    }, []);
    var favorite = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var _props_onSaveToBoard, boardToken, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setFavorited(true);
                        return [
                            4,
                            saveToBoard(productToken, saveToBoardContext.quickSaveBoardToken, props.productImage, saveToBoardContext.onSaveProductChange)
                        ];
                    case 1:
                        boardToken = _state.sent().boardToken;
                        savedToBoardTokenRef.current = boardToken;
                        (_props_onSaveToBoard = props.onSaveToBoard) === null || _props_onSaveToBoard === void 0 ? void 0 : _props_onSaveToBoard.call(props, boardToken);
                        if (saveToBoardContext.trackOrigin) {
                            trackBoardsEvent("product/".concat(productToken, "/save/").concat(saveToBoardContext.trackOrigin));
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        setFavorited(false);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function favorite() {
            return _ref.apply(this, arguments);
        };
    }();
    var unfavorite = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var _props_onRemoveFromBoard, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!savedToBoardTokenRef.current) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setFavorited(false);
                        return [
                            4,
                            removeFromBoard(productToken, savedToBoardTokenRef.current, props.brandToken, saveToBoardContext.onSaveProductChange)
                        ];
                    case 2:
                        _state.sent();
                        (_props_onRemoveFromBoard = props.onRemoveFromBoard) === null || _props_onRemoveFromBoard === void 0 ? void 0 : _props_onRemoveFromBoard.call(props, savedToBoardTokenRef.current);
                        trackBoardsEvent("product/".concat(productToken, "/remove/").concat(saveToBoardContext.trackOrigin));
                        savedToBoardTokenRef.current = undefined;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setFavorited(true);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function unfavorite() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFavoriteClick = function(event) {
        var _props_onHeartClicked;
        event.stopPropagation();
        event.preventDefault();
        (_props_onHeartClicked = props.onHeartClicked) === null || _props_onHeartClicked === void 0 ? void 0 : _props_onHeartClicked.call(props);
        if (favorited) {
            unfavorite();
        } else {
            favorite();
        }
    };
    var handleSelectBoard = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(boardTokenToUpdate) {
            var _props_onSaveToBoard, boardToken;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (_props_onSaveToBoard = props.onSaveToBoard) === null || _props_onSaveToBoard === void 0 ? void 0 : _props_onSaveToBoard.call(props, boardTokenToUpdate);
                        if (!savedToBoardTokenRef.current) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            moveToBoard(productToken, props.brandToken, savedToBoardTokenRef.current, boardTokenToUpdate, props.productImage)
                        ];
                    case 1:
                        boardToken = _state.sent().boardToken;
                        savedToBoardTokenRef.current = boardToken;
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectBoard(boardTokenToUpdate) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: props.className,
        "data-test-id": props["data-test-id"],
        children: [
            /*#__PURE__*/ _jsx(FavoriteButton, {
                favorited: favorited,
                onClick: handleFavoriteClick,
                light: props.iconLightVersion,
                size: props.iconSize,
                ariaLabel: favorited ? strictLocalize({
                    id: "eIFxM+",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Remove product from board"
                        }
                    ]
                }) : strictLocalize({
                    id: "9j2ud7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Save product to board"
                        }
                    ]
                })
            }),
            selectBoardModalOpen ? /*#__PURE__*/ _jsx(LazySelectBoardModal, {
                onClose: function() {
                    return setSelectBoardModalOpen(false);
                },
                initiallySelectedBoardToken: savedToBoardTokenRef.current,
                onSelect: handleSelectBoard
            }) : null
        ]
    });
};
var Wrapper = styled.div.withConfig({
    componentId: "sc-4aa5a5ff-0"
})([
    "position:relative;display:inline-block;z-index:1;pointer-events:auto;"
]);
